import * as languageMap from "shared/languageMap";

export type UserFlagKey =
  | "askAI"
  | "showTransliterations"
  | "contextTranslations"
  | "betterAIModel"
  | "hideCompleted"
  | "disableMarginButtons"
  | "explainTitleAndAuthor";

interface FeatureFlagInfo {
  key: UserFlagKey;
  description: string;
  availableTo: "god" | "premium" | "free" | "plus";
  experimental: boolean;
  defaultValue?: boolean;
  forumLink?: string;
}

/** User flags in the order in which they'll appear within the Settings page */
export const userFlags: FeatureFlagInfo[] = [
  {
    key: "showTransliterations",
    description: `Show transliterations when learning the following languages: ${languageMap.list
      .filter((language) => language.transliterations)
      .map((language) => language.english)
      .join(", ")}.`,
    availableTo: "free",
    experimental: false,
    defaultValue: true,
    forumLink:
      "https://forum.readlang.com/t/calling-japanese-and-chinese-learners-please-try-new-furigana-and-pinyin-feature-experimental/284",
  },
  {
    key: "askAI",
    description:
      "Ask AI for help in Explanation tab and Edit mode of Blitz and Mastery practice modes.",
    availableTo: "premium",
    experimental: true,
    forumLink:
      "https://forum.readlang.com/t/ask-ai-custom-chatgpt-prompt-feature-for-premium-users-experimental/152",
  },
  {
    key: "contextTranslations",
    description:
      "Uses ChatGPT instead of Google Translate to provide context-aware translations. Typically more accurate but slower.",
    availableTo: "premium",
    experimental: false,
    defaultValue: true,
  },
  {
    key: "betterAIModel",
    description:
      "Uses GPT-4o instead of GPT-4o mini for all AI powered features: Context Translations, Context Explanations, Review Summaries, and Ask AI. In general this will be slower but more accurate. Eventually, this feature is likely to be part of a more expensive premium plan.",
    availableTo: "plus",
    experimental: false,
    defaultValue: true,
    forumLink:
      "https://forum.readlang.com/t/experimental-option-to-use-full-gpt-4o-model-for-ai-features/690",
  },
  {
    key: "hideCompleted",
    description: "Hide completed texts from the public library.",
    availableTo: "free",
    experimental: true,
    // forumLink: "",
  },
  {
    key: "disableMarginButtons",
    description:
      "Disable the ability to click the page margins to flip pages. With this enabled you will need to instead click the buttons at the bottom of the page instead.",
    availableTo: "free",
    experimental: true,
    // forumLink: "",
  },
  {
    key: "explainTitleAndAuthor",
    description:
      "Designed for people who want to read well-known texts where the language may differ from the commonly spoken language of the day. e.g. Shakespeare, Mark Twain, or Cervantes. By selecting this option, the AI explanations will take the source into account. LIMITATION: These explanations will not show up within the card edit view or within practice, they are only available within the reading interface sidebar.",
    availableTo: "premium",
    experimental: true,
    // forumLink: "",
  },
];

export const globalFlags = {
  // None at the moment
};
